import { Button, Pencil } from '../../../../modules/design-system';
import type { IframePoolOrderItem } from '../../../../modules/api';
import { ShippingItemCard } from '../../shared';

export interface ShippingListSectionProps {
  items: IframePoolOrderItem[];
  /** Sends the user back to the Cards tab so they can pick items via the
   *  same Buyback-selection flow already in place. Also wired to the
   *  pencil button in the section header. */
  onChooseItems: () => void;
}

/**
 * "Shipping List" section. Inherits the items selected on the Cards tab
 * (`selected: Set<string>` in MyPacksPage). Empty selection → empty
 * state + CTA that bounces the user back to Cards to pick items.
 *
 * Rendered inside the outer Delivery glass container.
 */
export function ShippingListSection({ items, onChooseItems }: ShippingListSectionProps) {
  return (
    <section>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3
            className="text-[17px] font-bold tracking-[-0.3px]"
            style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
          >
            Shipping List
          </h3>
          <p
            className="mt-1 text-[12px]"
            style={{ color: 'rgba(255,255,255,0.55)' }}
          >
            Review and edit the cards in your shipment
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onChooseItems}
          aria-label="Edit shipping list"
          leftIcon={<Pencil size={24} strokeWidth={1.73} />}
        >
          {/*<div><Pencil size={24} strokeWidth={1.73} /></div>*/}
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="mt-4 flex flex-col items-start gap-3">
          <p className="text-[14px]" style={{ color: 'rgba(255,255,255,0.55)' }}>
            No items selected
          </p>
          <Button variant="primary" size="md" onClick={onChooseItems}>
            Choose Items
          </Button>
        </div>
      ) : (
        <ul className="mt-4 grid grid-cols-2 gap-3 @[600px]:grid-cols-3">
          {items.map((it) => (
            <li key={it.id}>
              <ShippingItemCard imageUrl={it.imageUrl} title={it.title} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
